import React, { useCallback } from 'react';
import './MapPanel.css';

const MapPanel = ({ 
  mapElementRef, 
  mapInstance,
  mapLoading, 
  mapError, 
  onRetry, 
  onRefresh 
}) => {
  const handleZoomIn = useCallback(() => {
    if (mapInstance?.setZoom && mapInstance?.getZoom) {
      mapInstance.setZoom(mapInstance.getZoom() + 1);
    }
  }, [mapInstance]);

  const handleZoomOut = useCallback(() => {
    if (mapInstance?.setZoom && mapInstance?.getZoom) {
      mapInstance.setZoom(mapInstance.getZoom() - 1);
    }
  }, [mapInstance]);

  return (
    <div className="map-panel">
      <div className="map-container">
        <div
          className="map-wrapper"
          style={{
            width: '100%',
            height: '100%',
            position: 'relative',
          }}
        >
          {mapLoading && (
            <div className="map-loading" style={{ position: 'absolute', inset: 0, zIndex: 2 }}>
              <div className="loading-spinner"></div>
              <p>Loading map...</p>
            </div>
          )}
          {mapError && (
            <div className="map-error" style={{ position: 'absolute', inset: 0, zIndex: 2 }}>
              <p>{mapError}</p>
              <div className="error-actions">
                <button onClick={onRetry}>Retry</button>
                <button onClick={onRefresh}>Refresh Page</button>
              </div>
            </div>
          )}
          {!mapLoading && !mapError && !window.google && (
            <div className="map-placeholder" style={{ position: 'absolute', inset: 0, zIndex: 2 }}>
              <div className="map-content">
                <div className="map-labels">
                  <div className="map-label">Waterloo East</div>
                  <div className="map-label">South Bank</div>
                  <div className="map-label">Waterloo</div>
                  <div className="map-label">Imperial War Museums</div>
                  <div className="map-label">Churchill War Rooms</div>
                  <div className="map-label">Big Ben</div>
                  <div className="map-label">Westminster Abbey</div>
                  <div className="map-label">Palace of Westminster</div>
                  <div className="map-label">Lambeth</div>
                  <div className="map-label">Vauxhall</div>
                  <div className="map-label">Tate Britain</div>
                  <div className="map-label">Kennington</div>
                </div>
              </div>
            </div>
          )}
          <div
            ref={mapElementRef}
            className="google-map"
            data-map-container="true"
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              inset: 0,
              zIndex: 1,
            }}
          />
        </div>

        {/* Figma-style overlay controls */}
        {!mapLoading && !mapError && (
          <div className="map-overlay-controls">
            {/* Expand / toggle button */}
            <button
              className="map-toggle-btn"
              onClick={onRefresh}
              title="Reset map"
              aria-label="Reset map"
            >
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 3H21V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9 21H3V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M21 3L14 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M3 21L10 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            {/* Zoom controls */}
            <div className="map-zoom-controls">
              <button
                className="map-zoom-btn"
                onClick={handleZoomIn}
                title="Zoom in"
                aria-label="Zoom in"
              >
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 5V19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <div className="map-zoom-divider" />
              <button
                className="map-zoom-btn"
                onClick={handleZoomOut}
                title="Zoom out"
                aria-label="Zoom out"
              >
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MapPanel;
